import { ProductGroupAttributeValue } from './ProductGroupAttributeValue';

/**
 * ProductGroupAttribute - one variation dimension of a group (e.g. "Tamaño", "Color").
 *
 * Attributes are arbitrary and defined per group, so a group can expose any number of
 * option types with any number of values.
 */
export class ProductGroupAttribute {
  constructor(data = {}) {
    this.id = data.id || null;
    this.code = data.code || null;
    this.name = data.name || null;
    this.position = data.position !== undefined && data.position !== null ? data.position : 0;
    this.values = (data.values || []).map(ProductGroupAttributeValue.fromJSON).filter(Boolean);
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    return new ProductGroupAttribute({
      id: json.id,
      code: json.code,
      name: json.name,
      position: json.position,
      values: json.values,
    });
  }

  toJSON() {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      position: this.position,
      values: this.values.map((value) => value.toJSON()),
    };
  }
}
